import React, { useEffect, useRef } from 'react'
import { Animated, Dimensions, Easing, StyleSheet, View } from 'react-native'

function ConfettiCelebration() {

  const CONFETTI_COLORS =['#E53935', '#FFB300', '#43A047', '#1E88E5', '#8E24AA', '#F06292', '#FF7043', '#26C6DA']
  const CONFETTI_COUNT = 40
  const { height: SCREEN_HEIGHT, width: SCREEN_WIDTH } = Dimensions.get('window')

  const anims = useRef(
    Array.from({ length: CONFETTI_COUNT }, () => ({
      translateY: new Animated.Value(0),
      translateX: new Animated.Value(0),
      rotateZ: new Animated.Value(0),
      rotateX: new Animated.Value(0),
      scaleX: new Animated.Value(1),
      opacity: new Animated.Value(1),
    }))
  ).current

  const pieces = useRef(
    Array.from({ length: CONFETTI_COUNT }, () => ({
      color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
      startX: Math.random() * SCREEN_WIDTH,
      width: 6 + Math.random() * 6,
      height: 10 + Math.random() * 8,
      delay: Math.random() * 800,
      duration: 2200 + Math.random() * 1200,
      drift: (Math.random() - 0.5) * 180,
      zRotations: 2 + Math.random() * 5,
      xRotations: 3 + Math.random() * 6,
      flipSpeed: 400 + Math.random() * 300,
    }))
  ).current

  useEffect(() => {
    anims.forEach((anim, i) => {
      const { delay, duration, drift, zRotations, xRotations, flipSpeed } = pieces[i]
      const flipCount = Math.ceil(duration / flipSpeed)
      const flipSequence = Array.from({ length: flipCount }, (_, j) => (
        Animated.timing(anim.scaleX, { toValue: j % 2 === 0 ? -1 : 1, duration: flipSpeed, useNativeDriver: true })
      ))
      Animated.parallel([
        Animated.timing(anim.translateY, { toValue: SCREEN_HEIGHT + 40, duration, delay, easing: Easing.in(Easing.quad), useNativeDriver: true }),
        Animated.timing(anim.translateX, { toValue: drift, duration, delay, useNativeDriver: true }),
        Animated.timing(anim.rotateZ, { toValue: zRotations, duration, delay, useNativeDriver: true }),
        Animated.timing(anim.rotateX, { toValue: xRotations, duration, delay, useNativeDriver: true }),
        Animated.sequence([Animated.delay(delay), ...flipSequence]),
        Animated.sequence([
          Animated.delay(delay + duration * 0.7),
          Animated.timing(anim.opacity, { toValue: 0, duration: duration * 0.3, useNativeDriver: true }),
        ]),
      ]).start()
    })
  }, [anims, pieces])

  return (
    <View style={styles.confettiContainer} pointerEvents="none">
      {anims.map((anim, i) => {
        const spinZ = anim.rotateZ.interpolate({ inputRange: [0, 1], outputRange: ['0deg', '360deg'] })
        const spinX = anim.rotateX.interpolate({ inputRange: [0, 1], outputRange: ['0deg', '360deg'] })
        return (
          <Animated.View
            key={i}
            style={[
              styles.confettiPiece,
              {
                backgroundColor: pieces[i].color,
                width: pieces[i].width,
                height: pieces[i].height,
                left: pieces[i].startX,
                borderRadius: pieces[i].width > 9 ? pieces[i].width / 2 : 2,
                transform: [
                  { translateY: anim.translateY },
                  { translateX: anim.translateX },
                  { rotateZ: spinZ },
                  { rotateX: spinX },
                  { scaleX: anim.scaleX },
                ],
                opacity: anim.opacity,
              },
            ]}
          />
        )
      })}
    </View>
  )
}


const styles = StyleSheet.create({
  confettiContainer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 10,
  },
  confettiPiece: {
    position: 'absolute',
    top: -20,
  }
})

export default ConfettiCelebration
